import React, { Fragment, useContext } from "react";
import { setSubscriptionInfo, SUBSCRIPTION_INFO_NEXT_DATE_CACHE_ID } from "../services/monsum/subscription/set-subscription-info";
import AuthContext from "../services/firebase/auth-context/provider";
import FirebaseHandler from "../services/firebase";
import { getItem, hasItem, setItem } from "../services/cache/cache";
var SetSubscriptionInfo = function SetSubscriptionInfo() {
    var _useContext$ = useContext(AuthContext)[0], user = _useContext$.user, authenticated = _useContext$.authenticated;
    if (shouldSetSubscriptionInfo(authenticated, user)) {
        setSubscriptionInfo(user === null || user === void 0 ? void 0 : user.email).then(function () {
            FirebaseHandler.auth.currentUser.getIdToken(true).then();
            saveSubscriptionInfoNextDate();
        }).catch(function () {
            saveSubscriptionInfoNextDate();
        });
    }
    return /*#__PURE__*/ React.createElement(Fragment, null);
};
export default SetSubscriptionInfo;
var shouldSetSubscriptionInfo = function shouldSetSubscriptionInfo(authenticated, user) {
    if (!authenticated || !user || !user.email)
        return false;
    if (hasItem("LOCAL_STORAGE", "SUBSCRIPTION_INFO", SUBSCRIPTION_INFO_NEXT_DATE_CACHE_ID)) {
        var nextDate = new Date(getItem("LOCAL_STORAGE", "SUBSCRIPTION_INFO", SUBSCRIPTION_INFO_NEXT_DATE_CACHE_ID));
        if (new Date() < nextDate)
            return false;
    }
    return true;
};
var saveSubscriptionInfoNextDate = function saveSubscriptionInfoNextDate() {
    var nextDate = new Date();
    nextDate.setDate(nextDate.getDate() + 7);
    setItem("LOCAL_STORAGE", "SUBSCRIPTION_INFO", SUBSCRIPTION_INFO_NEXT_DATE_CACHE_ID, nextDate);
};
